export default __webpack_public_path__ + "static/media/admin.b2a6bf89.png";